import { cn, momentZone, zoneHint, zoneLabel, zoneTag } from '@/shared/lib'

interface ZoneNoteProps {
  // Слово перед тегом: «время» в заголовке колонки или секции. У одиночного
  // момента тег стоит прямо за значением и подписи не требует.
  label?: string
  // Со смещением («Москва · UTC+3») — для экранов, где бейджа зоны в шапке
  // может не быть: гость по внешней ссылке заходит с телефона, и своё смещение
  // ему стоит увидеть рядом со временем, а не выводить из имени зоны.
  full?: boolean
  className?: string
}

// Подпись зоны показа момента — зоны устройства смотрящего: короткий тег рядом
// со значением или в заголовке колонки, один раз на колонку, а не в каждой
// строке. Полная фраза живёт в подсказке и уходит скринридеру: «Москва» рядом с
// 14:30 сама по себе читается как место встречи, а не как зона.
export function ZoneNote({ label, full = false, className }: ZoneNoteProps) {
  const tz = momentZone()
  const hint = zoneHint(tz)
  return (
    <span
      title={hint}
      className={cn('font-mono text-[11px] leading-4 text-text-tertiary', className)}
    >
      {label ? `${label} · ` : ''}
      {full ? zoneLabel(tz) : zoneTag(tz)}
      <span className="sr-only"> — {hint}</span>
    </span>
  )
}
